import React from "react";
import { motion } from "framer-motion";
import styled from "styled-components";

const AnimateUpStyles = styled.div`
  overflow: hidden;
  width: 100%;
  display: flex;
  position: relative;
  z-index: 7;
  @media ${(props) => props.theme.breakpoints.m} {
    justify-content: center;
  }
`;

type AnimateUpProps = {
  children: React.ReactNode;
  delay: number;
};

const AnimateUp = ({ children, delay }: AnimateUpProps) => {
  return (
    <AnimateUpStyles>
      <motion.div
        initial={{ y: "101%" }}
        animate={{ y: 0 }}
        transition={{ delay: delay, ease: "easeOut", duration: 0.7 }}
      >
        {children}
      </motion.div>
    </AnimateUpStyles>
  );
};

export default AnimateUp;
